import { KnowledgeManager } from '@/components/admin/knowledge/KnowledgeManager';

export default function PlatformKnowledge() {
  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h2 className="text-2xl font-heading font-semibold">House knowledge</h2>
        <p className="text-sm text-muted-foreground">
          IV Talent methodology, playbooks, intervention library and research notes. Available to
          every tenant's Ask, editable only from the platform console.
        </p>
      </div>

      <KnowledgeManager
        scope="house"
        title="Methodology and playbooks"
        description="Retrieved across all tenants when Ask writes recommendations."
      />
    </div>
  );
}
